import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import {
  approveGstStatus,
  blockUser,
  deleteCategory,
  disapproveGstStatus,
  getCountries,
  getCountryAvgData,
  getCrowdAvgHighData,
  getDashboardLeadingData,
  getDashboardUserTest,
  getExtraAvgHighData,
  getImgHitData,
  getPracticeAvgHighData,
  getUser,
  getUserTestAvg,
  unblockUser,
  updateGstStatus,
} from "services/ApiService"
import { Row, Col, Card, CardBody, CardTitle, Container } from "reactstrap"
import TableContainer from "../../components/Common/TableContainer"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Pie from "../AllCharts/echart/piechart"
import Doughnut from "../AllCharts/echart/doughnutchart"

import { toast, ToastContainer } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLock, faUnlock } from "@fortawesome/free-solid-svg-icons"
import Loader from "components/Common/Loader"
import HighchartsReact from "highcharts-react-official"
import Highcharts from "highcharts"
import CrowdChart from "components/charts/CrowdChart"
import PracticeChart from "components/charts/PracticeChart"
import HitsByImgTypeChart from "components/charts/HitsByImgTypeChart"
import ExtraAvgHighChart from "components/charts/ExtraAvgHighChart"
import CountryAvgData from "components/Common/CountryAvgData"
import MiniWidget from "./mini-widget"
import UserDataTable from "components/Common/UserDataTable"
import { base_url } from "utils/APIUrls"
import DashboardUserDataTable from "components/Common/DashboardUser"

// import Swal from "sweetalert2"
// import "sweetalert2/dist/sweetalert2.min.css"

function Dashboard() {
  const [data, setData] = useState([])
  const [countryAvgData, setCountryAvgData] = useState([])
  const [chartTab, setChartTab] = useState(0) //0 for day, 1 for week, 2 for month
  const [chartData, setChartData] = useState([])
  const [crowdChartData, setCrowdChartData] = useState([])
  const [practiceChartData, setPracticeChartData] = useState([])
  const [imgHitChartData, setImgHitChartData] = useState([])
  const [extraAvhHighData, setextraAvhHighData] = useState([])
  // img_hit
  const [countryData, setCountryData] = useState([])
  const [selectedCountry, setSelectedCountry] = useState("all")
  const [userTestAvgData, setuserTestAvgData] = useState(null)
  const [totalUser, setTotalUser] = useState(null)
  const [totalEvents, setTotalEvents] = useState(null)
  const [totalAvgScores, setTotalAvgScores] = useState(null)

  const [isLoading, setIsLoading] = useState(true)

  const fetchData = () => {
    getDashboardLeadingData(selectedCountry)
      .then(res => {
        setData(res.data)
        setIsLoading(false)
      })
      .catch(error => {
        toast.error(error)
        toast.error("Failed to fetch user data")
      })
  }

  useEffect(() => {
    fetchUserTestAvgData()
  }, [])

  const fetchCountryAvgData = () => {
    getCountryAvgData()
      .then(res => {
        setCountryAvgData(res.data)
        setIsLoading(false)
      })
      .catch(error => {
        toast.error(error)
        toast.error("Failed to fetch user data")
      })
  }

  const fetchUserTestAvgData = () => {
    getUserTestAvg()
      .then(res => {
        console.log("User test avg data from function:....", res.data[0])
        setTotalUser(res.data[0].totalUsers)
        setTotalEvents(res.data[0].totalEvents)
        setTotalAvgScores(res.data[0].averageCumulativeScore)
        // setuserTestAvgData(res.data[0])
      })
      .catch(error => {
        toast.error(error)
        toast.error("Failed to fetch user data")
      })
  }
  const getCountryData = () => {
    getCountries().then(res => {
      setCountryData(res.data)
      // console.log("country data", res.data)
    })
  }

  // console.log("selected country", selectedCountry)
  useEffect(() => {
    getCountryData()
    getCrowdChart()
    getPracticeChart()
    getImgChart()
    getExtraChart()
    fetchCountryAvgData()
  }, [])

  useEffect(() => {
    fetchData()
  }, [selectedCountry])

  useEffect(() => {
    getChartData()
  }, [chartTab])

  const getCrowdChart = () => {
    getCrowdAvgHighData().then(res => {
      setCrowdChartData(res.data)
      // console.log("Crowd chart data....", res.data)
    })
  }

  const getPracticeChart = () => {
    getPracticeAvgHighData().then(res => {
      setPracticeChartData(res.data)
      // console.log("Practice chart data....", res.data)
    })
  }

  const getImgChart = () => {
    getImgHitData().then(res => {
      setImgHitChartData(res.data)
      // console.log("Practice chart data....", res.data)
    })
  }

  const getExtraChart = () => {
    getExtraAvgHighData().then(res => {
      setextraAvhHighData(res.data)
      // console.log("Extra Avg High chart data....", res.data)
    })
  }

  console.log("data", data)

  const columns = useMemo(
    () => [
      {
        Header: "Country",
        accessor: "countryName",
      },
      {
        Header: "Score",
        accessor: "averageScore",
        Cell: ({ value }) => value?.toFixed(2),
      },

      {
        Header: "User Count",
        accessor: "userCount",
      },
    ],
    []
  ) // Add an empty dependency array

  //chart
  const getChartData = () => {
    let chartType = chartTab == 0 ? "day" : chartTab == 1 ? "week" : "month"
    getDashboardUserTest(chartType).then(res => {
      setChartData(res.data)
      // console.log("chart data....", res.data)
    })
  }

  const chartDay = [
    { date: "2025-02-21", user: 30, test: 85 },
    { date: "2025-04-12", user: 32, test: 96 },
    { date: "2025-03-20", user: 15, test: 85 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
    { date: "2025-01-02", user: 85, test: 87 },
  ]

  const chartWeek = [
    { week: "2025-W11", user: 130, test: 285 },
    { week: "2025-W10", user: 232, test: 296 },
    { week: "2025-W24", user: 15, test: 87 },
    { week: "2025-W01", user: 285, test: 187 },
    { week: "2025-W01", user: 285, test: 187 },
    { week: "2025-W01", user: 285, test: 187 },
    { week: "2025-W01", user: 285, test: 187 },
    { week: "2025-W01", user: 285, test: 187 },
    { week: "2025-W01", user: 285, test: 187 },
    { week: "2025-W01", user: 285, test: 187 },
    { week: "2025-W01", user: 285, test: 187 },
  ]

  const chartMonth = [
    { month: "April 2025", user: 130, test: 285 },
    { month: "May 2024", user: 232, test: 296 },
    { month: "June 2024", user: 15, test: 87 },
    { month: "January 2025", user: 285, test: 187 },
    { month: "January 2025", user: 2085, test: 187 },
    { month: "January 2025", user: 285, test: 187 },
    { month: "January 2025", user: 285, test: 187 },
    { month: "January 2025", user: 285, test: 1807 },
    { month: "January 2025", user: 285, test: 187 },
    { month: "January 2025", user: 285, test: 187 },
    { month: "January 2025", user: 285, test: 187 },
    { month: "January 2025", user: 285, test: 187 },
  ]
  // console.log("chart data", chartData)
  const labels = chartData.map(item => item.date || item.week || item.month)
  const userData = chartData.map(item => item.user)
  const testData = chartData.map(item => item.test)

  const chartOptions = {
    chart: {
      type: "area",
    },
    title: {
      text: "True ESP App", // Remove chart title
    },
    credits: {
      enabled: false, // Remove Highcharts watermark
    },
    xAxis: {
      categories: labels,
      title: {
        text: chartTab === 0 ? "Date" : chartTab === 1 ? "Week" : "Month",
      },
    },

    tooltip: {
      shared: true,
      valueSuffix: "",
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: true,
      },
    },
    series: [
      {
        name: "User",
        data: userData,
        color: "#2196F3", // Line color
        fillColor: {
          linearGradient: [0, 0, 0, 300],
          stops: [
            [0, "rgba(33, 150, 243, 0.5)"],
            [1, "rgba(33, 150, 243, 0)"],
          ],
        },
      },
      {
        name: "Test",
        data: testData,
        color: "#040989",
        fillColor: {
          linearGradient: [0, 0, 0, 300],
          stops: [
            [0, "#3c269c"], // Top of the area
            [1, "rgba(142, 120, 229, 0)"],
          ],
        },
      },
    ],
  }

  console.log("userTestAvgData from state...", userTestAvgData)
  const reports = [
    {
      icon: "bx bx-copy-alt",
      title: "Users",
      value: totalUser,
    },
    {
      icon: "bx bx-archive-in",
      title: "Events",
      value: totalEvents,
    },
    {
      icon: "bx bx-purchase-tag-alt",
      title: "Average Scores",
      value: Number(totalAvgScores).toFixed(2),
    },
  ]

  // console.log("totalUSer-Avgscr-Test", totalAvgScores + totalUser + totalEvents)

  //meta title
  document.title = "Dashboard | True-ESP Dashboard "

  return (
    <div className="page-content">
      <Breadcrumbs title="Dashboard" breadcrumbItem="Dashboard" />

      <ToastContainer />
      <div className="container-fluid">
        <div className="">
          <Row>
            <Col xl="8">
              <Row>
                {/*mimi widgets */}
                <MiniWidget reports={reports} />
              </Row>
            </Col>
          </Row>
          <Row>
            <Col lg="4">
              <div className="">
                <form action="">
                  <select
                    name=""
                    id=""
                    className="form-select"
                    onChange={e => setSelectedCountry(e.target.value)}
                  >
                    <option value="all">All</option>
                    {countryData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </form>
              </div>
              {data.length > 0 ? (
                // <TableContainer
                //   columns={columns}
                //   data={data}
                //   isPagination={false}
                //   tableClass="align-middle table-nowrap table-check table table-div"
                //   theadClass="table-light"
                // />
                <table className="table table-hover table-bordered text-center mt-2">
                  <thead className="table-light">
                    <tr>
                      <th className="text-center">Name</th>
                      <th className="text-center">Country</th>
                      <th className="text-center">Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* `${row.firstname}  ${row.lastname} */}
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.firstname + " " + item.lastname}</td>
                        <td>{item.countryName}</td>
                        <td>{item.cumulativeScore}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="text-center">
                  <h5 className="mt-2 text-muted">No data available</h5>
                </div>
              )}
            </Col>
            <Col lg="8">
              <Card>
                <div>
                  <div className="flex space-x-2  ">
                    <button
                      onClick={() => setChartTab(0)}
                      className={`px-4 py-2 rounded-lg transition-all duration-300 border border-blue-800 ${chartTab === 0
                        ? "bg-blue-800 text-gray shadow-md"
                        : "bg-white text-muted hover:bg-blue-100"
                        }`}
                    >
                      Day
                    </button>

                    <button
                      onClick={() => setChartTab(1)}
                      className={`px-4 py-2 rounded-lg transition-all duration-300 border border-blue-600 ${chartTab === 1
                        ? "bg-blue-600 text-gray shadow-md "
                        : "bg-white text-muted hover:bg-blue-100"
                        }`}
                    >
                      Week
                    </button>

                    <button
                      onClick={() => setChartTab(2)}
                      className={`px-4 py-2 rounded-lg transition-all duration-300 border border-blue-600 ${chartTab === 2
                        ? "bg-blue-600 text-gray shadow-md"
                        : "bg-white text-muted  hover:bg-blue-100"
                        }`}
                    >
                      Month
                    </button>
                  </div>
                </div>
                <CardBody>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="m-1 mb-4">
            <Col lg="12" className="border border-gray-300 rounded-lg bg-white py-4">
              <DashboardUserDataTable
                apiURL={`${base_url}/admin/v1/user/dashboard-user-events`}
                idName="dashboardUser"
              // countries={country}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <CrowdChart data={crowdChartData} />
            </Col>
            <Col lg="12">
              <PracticeChart data={practiceChartData} />
            </Col>
            <Col lg="12">
              <ExtraAvgHighChart data={extraAvhHighData} />
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <HitsByImgTypeChart data={imgHitChartData} />
            </Col>
            <Col lg="6">
              {/* <CountryAvgData
                apiURL="http://trueesp.com:3000/admin/v1/user/dashboard-by-country-average"
                idName="country"
              /> */}
              <TableContainer
                columns={columns}
                data={countryAvgData}
                isGlobalFilter={true}
                isAddOptions={false}
                customPageSize={10}
                isPagination={true}
                isShowingPageLength={true}
                tableClass="align-middle table-nowrap table-check table table-div"
                theadClass="table-light"
                paginationDiv="col-12"
                pagination="justify-content-center pagination pagination-rounded"
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

Dashboard.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Dashboard
